import React from "react";
import { Descriptions, Space, Typography } from "@payping/web-components";
import { useAppDispatch, useAppSelector, useAppTranslation } from "@/utils";
import { useAsyncRetry } from "react-use";
import { getPersonalInfo, getUserPhoneNumber } from "@payping/redux/actions";
import { dateFormats, toJalali } from "@payping/utils/dateUtils";
import { buildUrl } from "@payping/utilities-shared/url";
import { URLS } from "@payping/utilities-shared/consts";

const ProfileDetail: React.FC = () => {
  const { t } = useAppTranslation();
  const dispatch = useAppDispatch();
  const personalInfo = useAppSelector((state) => state.user.personalInfo);
  const username = useAppSelector((state) => state.user.personalInfo?.username);
  const url = buildUrl(URLS.BASE_URL, `@${username}`).toString();

  useAsyncRetry(async () => {
    await dispatch(getPersonalInfo());
    await dispatch(getUserPhoneNumber());
  }, [dispatch]);
  return (
    <Space direction={"vertical"} size={"middle"} className={"tw-w-full"}>
      <Typography.Title level={4} className="tw-font-medium">
        {t("profile.title")}
      </Typography.Title>
      <Descriptions column={2}>
        <Descriptions.Item label={t("common.username")}>{personalInfo?.username}</Descriptions.Item>
        <Descriptions.Item label={t("email")}>{personalInfo?.email}</Descriptions.Item>
        <Descriptions.Item label={t("common.linkPersonalPage")}>{url}</Descriptions.Item>
        <Descriptions.Item label={t("mobileNumber")}>{personalInfo?.phoneNumber}</Descriptions.Item>
        <Descriptions.Item label={t("firstName")}>{personalInfo?.firstName}</Descriptions.Item>
        <Descriptions.Item label={t("birthDate")}>
          {
            toJalali({
              date: personalInfo?.birthDate,
              dateFormat: dateFormats.ui.utcDateTime,
              toFormat: dateFormats.ui.utcDate,
            }).string
          }
        </Descriptions.Item>
        <Descriptions.Item label={t("lastName")}>{personalInfo?.lastName}</Descriptions.Item>
        <Descriptions.Item label={t("nationalCode")}>{personalInfo?.nationalCode}</Descriptions.Item>
      </Descriptions>
    </Space>
  );
};

export default ProfileDetail;
